import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, Eyebrow } from "../site/Reveal";

const ParallaxImage = ({ src, alt, className = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <div ref={ref} className={`relative overflow-hidden rounded-[2rem] ${className}`}>
      <motion.img style={{ y }} src={src} alt={alt} loading="lazy" className="absolute inset-0 h-[118%] -top-[9%] w-full object-cover" />
    </div>
  );
};

export const Segment = ({ id, dark = false, reverse = false, eyebrow, title, text, points, image, alt, cta, to, testId }) => (
  <section id={id} data-testid={testId} className={`${dark ? "bg-forest text-white" : "bg-white"} py-24 sm:py-32`}>
    <div className={`container-x grid items-center gap-12 lg:grid-cols-12 lg:gap-16`}>
      <Reveal className={`lg:col-span-6 ${reverse ? "lg:order-2" : ""}`}>
        <ParallaxImage src={image} alt={alt} className="aspect-[4/5] max-h-[80vh] w-full sm:aspect-[5/4] lg:aspect-[4/5]" />
      </Reveal>
      <div className={`lg:col-span-6 ${reverse ? "lg:order-1" : ""}`}>
        <Eyebrow light={dark}>{eyebrow}</Eyebrow>
        <Reveal><h2 className={`mt-5 font-display text-4xl font-semibold leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-forest"}`}>{title}</h2></Reveal>
        <Reveal delay={0.08}><p className={`mt-6 text-base leading-relaxed md:text-lg ${dark ? "text-white/80" : "text-ink/75"}`}>{text}</p></Reveal>
        <ul className="mt-8 space-y-4">
          {points.map((p, i) => (
            <Reveal as="li" key={p} delay={0.1 + i * 0.06} className={`flex items-start gap-3 border-t pt-4 ${dark ? "border-white/15 text-white/90" : "border-forest/10 text-ink/85"}`}>
              <Check className={`mt-0.5 h-5 w-5 shrink-0 ${dark ? "text-leaf" : "text-leaf-ink"}`} />{p}
            </Reveal>
          ))}
        </ul>
        <Reveal delay={0.2}><Link to={to} className="btn-gold group mt-10" data-testid={`${testId}-cta`}>{cta} <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" /></Link></Reveal>
      </div>
    </div>
  </section>
);
